import { fetchPageData } from "../utils/fetch";

export const login = async (authData) => {
  const endpoint = "auth/signin";
  const method = "POST";
  const err = "Could not authenticate you!";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    null,
    authData
  );
  return fetchedData;
};

export const signup = async (authData) => {
  const endpoint = "auth/signup";
  const method = "POST";
  const err = "Could not authenticate you!";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    null,
    authData
  );
  return fetchedData;
};

export const verify = async (token) => {
  const endpoint = `auth/verify/${token}`;
  const method = "get";
  const err = "Could not authenticate you!";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};
